import axios from 'axios';
import { configRefs } from '@utils/config';

async function getCoursesForStudentRequest(studentId) {
  const response = await axios.get(`${await configRefs.apis.userdata.get()}/api/Shares/Courses?userID=${encodeURIComponent(studentId)}&version=2`);

  // The Shares API may return the same course multiple times, however it only
  // makes logical sense to see it once in the frontend, hence we de-duplicate
  // this request.
  const deduped = [...new Map(response.data.map(item => [item.sharedObjectID, item])).values()];
  return deduped.map(rawCourse => ({
    __internalId: rawCourse.sharedObjectID,
    id: rawCourse.sharedObjectID,
    ownerId: null,
    createdAt: new Date(rawCourse.created * 1000),
    modifiedAt: new Date(rawCourse.modified * 1000),
    title: rawCourse.title,
    subjects: rawCourse.subjects,
    levels: rawCourse.levels
  }));
}

export { getCoursesForStudentRequest };
//# sourceMappingURL=request.get-all.student.js.map
